import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(weekday)
dayjs.extend(localeData)

export type TDatePickerValue = {
  toDate: () => Date
}

type TDateBoundary = 'start' | 'end' | 'preserve'

export const toJakartaISOString = (
  value: TDatePickerValue,
  boundary: TDateBoundary = 'preserve',
) => {
  const jakartaDate = dayjs(value.toDate()).tz('Asia/Jakarta')

  if (boundary === 'start') return jakartaDate.startOf('date').toISOString()
  if (boundary === 'end') return jakartaDate.endOf('date').toISOString()

  return jakartaDate.toISOString()
}
